import { UseMutationOptions } from '@tanstack/react-query';
import { AdminUserDto, TenantDetails } from '../types.gen';
import axiosClient, { axiosClientAdmin } from '@/lib/auth';
import {
  MessageReturnBase,
  PostDoTokenResetAuthData,
  PostLoginAuthData,
  PostLoginAuthResponse,
  PostMonitoringLoginAuthData,
  PostMonitoringLoginAuthResponse,
} from '../types.gen';

export type RedeemTokenInput = {
  token: string;
};

export type RedeemTokenResponse = {
  monitoringToken?: string;
  adminToken?: string;
  tenant: TenantDetails
  user: AdminUserDto;
};

export const redeemToken = async (input: RedeemTokenInput) => {
  const path = '/Oidc/redeem';

  const { data } = await axiosClientAdmin.post<RedeemTokenResponse>(path, input);

  return data;
};

export const RedeemTokenMut = () => {
  return {
    mutationKey: ['token.redeem'],
    mutationFn: redeemToken,
  } satisfies UseMutationOptions<any, any, any, any>;
};

export type ResetPasswordInput = Required<PostDoTokenResetAuthData['body']>;

export const resetPassword = async (input: ResetPasswordInput) => {
  const path: PostDoTokenResetAuthData['url'] = '/Auth/DoTokenReset';

  const { data } = await axiosClient.post<MessageReturnBase>(path, input);

  return data;
};

export const ResetPasswordMut = () => {
  return {
    mutationKey: ['reset-password'],
    mutationFn: resetPassword,
  } satisfies UseMutationOptions<any, any, any>;
};

export type LoginEmailPasswordInput = PostMonitoringLoginAuthData['body'];

export const loginMonitorEmailPassword = async (input: LoginEmailPasswordInput) => {
  const path: PostMonitoringLoginAuthData['url'] = '/Auth/monitoring/Login';

  const { data } = await axiosClient.post<PostMonitoringLoginAuthResponse>(path, {
    email: input?.email?.trim(),
    password: input?.email?.trim(),
  });

  return data;
};

export const loginAdminEmailPassword = async (input: LoginEmailPasswordInput) => {
  const path: PostLoginAuthData['url'] = '/Auth/Login';

  const { data } = await axiosClientAdmin.post<PostLoginAuthResponse>(path, {
    email: input?.email?.trim(),
    password: input?.email?.trim(),
  });

  return data;
};
